import { x25519 } from '@noble/curves/ed25519.js'
import { chacha20poly1305 } from '@noble/ciphers/chacha.js'
import { hkdf } from '@noble/hashes/hkdf.js'
import { sha256 } from '@noble/hashes/sha2.js'

// Mirrors hearth-cmd/cmd/hearth-cloud/secrets_crypto.go:encryptToHostPubkey
// and hearth-cmd-cli/secrets_crypto.go:encryptSecretEnvelope.
//
// Wire format: ephemeral_pubkey(32) || nonce(12) || ciphertext+tag(16).
// X25519 ECDH → HKDF-SHA256(salt=nil, info=nil) → ChaCha20-Poly1305 seal.
export function encryptToHostPubkey(
  rawHostPubkey: Uint8Array,
  plaintext: Uint8Array,
): Uint8Array {
  if (rawHostPubkey.length !== 32) {
    throw new Error(`host pubkey must be 32 bytes (X25519), got ${rawHostPubkey.length}`)
  }
  const ephSecret = x25519.utils.randomSecretKey()
  const ephPub = x25519.getPublicKey(ephSecret)
  const shared = x25519.getSharedSecret(ephSecret, rawHostPubkey)
  const symKey = hkdf(sha256, shared, undefined, undefined, 32)
  const nonce = crypto.getRandomValues(new Uint8Array(12))
  const sealed = chacha20poly1305(symKey, nonce).encrypt(plaintext)

  const out = new Uint8Array(32 + 12 + sealed.length)
  out.set(ephPub, 0)
  out.set(nonce, 32)
  out.set(sealed, 44)
  return out
}

export function base64Encode(bytes: Uint8Array): string {
  let s = ''
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i])
  return btoa(s)
}

export function base64Decode(b64: string): Uint8Array {
  const s = atob(b64)
  const out = new Uint8Array(s.length)
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i)
  return out
}
